window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

var url = new URL(window.location.href);
var target_domain = `sunnyextensions.com`;
var url_hostname = url.hostname;
var url_pathname = url.pathname;
console.log(`Hostname: ${url_hostname}, Pathname: ${url_pathname}`);
if (url_hostname != target_domain && url_hostname != `admin.shopify.com` && url_hostname != `sunnyhair.myshopify.com`) {
  window.location.href = `https://${target_domain}${url_pathname}`;
}

// 1. 每个页面先默认 不同意追踪 及 不接受 cookie
gtag("consent", "default", {
  analytics_storage: "denied",
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  wait_for_update: 500,
  region: [
    // to apply default to specific countries only
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FR",
    "GR",
    "HR",
    "HU",
    "IE",
    "IS",
    "IT",
    "LI",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "SE",
    "SI",
    "SK",
  ],
});

// 2. 根据用户之前是否同意的选项 在每个页面自动触发 代码同意追踪 及 cookie
if (localStorage["gtag.consent.option"] !== undefined) {
  const option = JSON.parse(localStorage["gtag.consent.option"]);
  gtag("consent", "update", option);
}

// 按钮的代码 给用户 同意 cookie
document.addEventListener("click", function (e) {
  const isAcceptAll = e.target.matches(
    "#shopify-pc__banner__btn-accept, #shopify-pc__prefs__header-accept"
  );
  if (isAcceptAll === false) return;

  const option = {
    analytics_storage: "granted",
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
  };
  gtag("consent", "update", option);

  // 3. 保存并记录用户是否同意的选项 以便下一页面自动选择是否同意 cookie
  localStorage["gtag.consent.option"] = JSON.stringify(option);
});

// 按钮的代码 给用户 拒绝 cookie
document.addEventListener("click", function (e) {
  const isRejectAll = e.target.matches(
    "#shopify-pc__banner__btn-decline, #shopify-pc__prefs__header-decline"
  );
  if (isRejectAll === false) return;

  const option = {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  };
  gtag("consent", "update", option);

  // 3b. 移除之前保存的用户同意选项的记录 以便下一页面不再自动同意 cookie
  localStorage.removeItem("gtag.consent.option");
});

// custom
document.addEventListener("click", function (e) {
  const isSaveCustom = e.target.matches(
    "#shopify-pc__prefs__dialog #shopify-pc__prefs__header-save"
  );
  if (isSaveCustom === false) return;

  const option = {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  };
  const form = e.target.closest("#shopify-pc__prefs__dialog");
  if (
    form.querySelector("#shopify-pc__prefs__analytics-input").checked === true
  ) {
    option.analytics_storage = "granted";
  }

  if (
    form.querySelector("#shopify-pc__prefs__marketing-input").checked === true
  ) {
    option.ad_storage = "granted";
    option.ad_user_data = "granted";
    option.ad_personalization = "granted";
  }

  gtag("consent", "update", option);

  // 3.c 保存并记录用户 自定义 的选项 以便下一页面自动选择是否同意特定的 cookie
  localStorage["gtag.consent.option"] = JSON.stringify(option);
});

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());

gtag("config", "G-C1YTMEX000");

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());

gtag("config", "AW-11088336380", { allow_enhanced_conversions: true });

window.addEventListener("load", function (event) {
  document
    .querySelectorAll(
      "[class='product-form--atc-button mdc-ripple-surface mdc-ripple-upgraded']"
    )
    .forEach(function (e) {
      e.addEventListener("click", function () {
        gtag("event", "sunnyaddtocart");
      });
    });
});

window.addEventListener("load", function () {
  if (window.location.href.includes("/products")) {
    gtag("event", "sunnyviewproducts");
  }
});

window.addEventListener("load", function (event) {
  document.querySelectorAll("[name='checkout']").forEach(function (e) {
    e.addEventListener("click", function () {
      gtag("event", "sunnybegincheckout");
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
    const currentHost = location.hostname;
    document.querySelectorAll('a[href^="http"]').forEach(function (link) {
      const linkHost = new URL(link.href).hostname;
      if (linkHost !== currentHost) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
      }
    });
  });
